
import { Component, Vue } from "vue-property-decorator";
import AuthHeader from "@/components/layout/auth-header.vue";
import Url from "@/lib/common/url";
import Auth from "@/lib/common/auth";
import { QuestionObject, Question } from "@/lib/model/question/question";
import EditStatus from "@/components/edit-status.vue";
@Component({
  components: {
    AuthHeader,
    EditStatus
  }
})
export default class Select extends Vue {
  isAnonymous = false;
  page = 1;
  pageSize = 10;
  paperId = "";
  search = {
    type: "",
    difficultLevel: "",
    descLike: "",
    companyIndex: ""
  }; //搜索条件对象
  questionList: Question[] = [new Question()];
  selectQuestionIdList: number[] = [];
  count = 0;
  selectAll = false;
  mounted() {
    Auth.init()
      .then(() => {
        this.isAnonymous = false;
        this.paperId = Url.query("paperId");
        (async () => {
          await this.updateList();
        })();
      })
      .catch(() => {
        this.isAnonymous = false;
      });
  }
  async updateList() {
    await this.getList();
    this.setImageMaxWidth();
  }
  setImageMaxWidth() {
    const elements = document.getElementsByClassName("hina-html");
    for (let i = 0; i < elements.length; i++) {
      const imgTags = elements[i].getElementsByTagName("img");
      for (let j = 0; j < imgTags.length; j++) {
        imgTags[i].style.maxWidth = "90%";
      }
    }
  }
  async getList() {
    const params = {
      type: "",
      difficultLevel: "",
      descLike: "",
      companyIndex: "",
      page: this.page,
      pageSize: this.pageSize
    };
    if (this.search.type) {
      params.type = this.search.type;
    }
    if (this.search.difficultLevel) {
      params.difficultLevel = this.search.difficultLevel;
    }
    if (this.search.descLike) {
      params.descLike = this.search.descLike;
    }
    if (this.search.companyIndex) {
      params.companyIndex = this.search.companyIndex;
    }
    let qo = new QuestionObject();
    qo = await QuestionObject.get(params);
    this.questionList = qo.list;
    this.count = qo.count;
    console.log(this.questionList);
    this.checkSelect();
  }
  filterBlankRule(a: number, b: number, c: number) {
    const aMap: { [key: number]: string } = {
      1: "完全一致",
      2: "顺序可不一致"
    };
    const bMap: { [key: number]: string } = {
      1: "出错得0分，全对得满分",
      2: "按答对比例给分",
      3: "各空分值独立设置"
    };
    const cMap: { [key: number]: string } = {
      1: "忽略答案中的空格",
      2: "不能忽略答案中的空格"
    };
    return aMap[a] + "； " + bMap[b] + "； " + cMap[c] + "；";
  }
  answerFilter(word: string) {
    return word.replace(/\|\|\|/g, " 或 ");
  }
  goBackStepTwo() {
    this.$router.push({
      path: "/paper/edit",
      query: {
        paperId: this.paperId,
        status: "add",
        companyId: Auth.companyId
      }
    });
  }
  selectOne(question: Question) {
    question.selected = !question.selected;
    if (
      question.selected &&
      !(question.questionId in this.selectQuestionIdList)
    ) {
      this.selectQuestionIdList.push(question.questionId);
    } else {
      this.selectQuestionIdList.forEach((id, index) => {
        if (id == question.questionId) {
          this.selectQuestionIdList.splice(index, 1);
        }
      });
    }
    this.checkAllSelect();
  }
  handleSelectAllChange() {
    if (this.selectAll) {
      this.questionList.forEach(question => {
        if (!question.selected) {
          question.selected = true;
          this.selectQuestionIdList.push(question.questionId);
        }
      });
    } else {
      this.questionList.forEach(question => {
        if (question.selected) {
          question.selected = false;
          this.selectQuestionIdList = this.selectQuestionIdList.filter(
            id => id != question.questionId
          );
        }
      });
    }
  }
  checkAllSelect() {
    let flag = true;
    this.questionList.forEach(question => {
      if (!question.selected) {
        flag = false;
        return;
      }
    });
    this.selectAll = flag;
    return flag;
  }
  checkSelect() {
    this.questionList.forEach(question => {
      if (question.questionId in this.selectQuestionIdList) {
        question.selected = true;
      }
    });
    this.checkAllSelect();
  }
}
